import {
  TabList as HeadlessTabList,
  type TabListProps as HeadlessTabListProps,
} from "@headlessui/react";
import classNames from "classnames";
import { useContext } from "react";

import TabContext from "./TabContext";

type TabListProps = HeadlessTabListProps<"div">;

export default function TabList({ className, ...props }: TabListProps) {
  const { size, variant, vertical } = useContext(TabContext);

  const sizes = {
    sm: "h-11",
    md: "h-12",
  };

  return (
    <HeadlessTabList
      {...props}
      className={classNames(
        "mb-5 flex",
        vertical ? "flex-col" : "flex-row overflow-x-auto overflow-y-hidden",
        variant === "primary" && !vertical
          ? "border-b"
          : variant === "secondary" &&
              "rounded-lg border border-gray-200 bg-gray-50 p-1",
        vertical ? "gap-1" : variant === "primary" ? "gap-4" : "gap-2.5",
        sizes[size],
        className,
      )}
    />
  );
}
